import './styles.scss'

import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Divider, Row } from 'antd'

import CustomButton from '@/components/CustomButton'
import { B2becButtonBack } from 'components/CustomButton/B2becButtonIcon'
import { SERVICE_ENTRY } from '@/libs/constants'

import ContactInformationSection from './components/ContactInformationSection'
import DeliveryAddressSection from './components/DeliveryAddressSection'

const AddressAndDateSelectStep = ({
  currentTab,
  handleChangeTab,
  serviceEntry = SERVICE_ENTRY.MAINTENANCE,
  form,
}) => {
  const { t } = useTranslation()

  const renderBackButtonText = useCallback(() => {
    switch (serviceEntry) {
      case SERVICE_ENTRY.MAINTENANCE: {
        return 'backToSelectMachine'
      }
      default: {
        return 'backToSelectService'
      }
    }
  }, [serviceEntry])

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col md={12} span={24}>
          <ContactInformationSection form={form} />
        </Col>
      </Row>

      <Row gutter={[24, 24]}>
        <Col md={12} span={24}>
          <DeliveryAddressSection />
        </Col>
      </Row>

      <div className="service-request__layout--shrink">
        <Divider />
      </div>

      {/* buttons wrapper */}
      <Row gutter={[24, 24]}>
        <Col
          lg={8}
          md={{ span: 12, order: 1 }}
          sm={{ order: 2 }}
          span={24}
          xs={{ order: 2 }}
        >
          <div className="service-request__layout--shrink">
            <B2becButtonBack
              block
              type="ghost"
              onClick={() => {
                handleChangeTab(+currentTab - 1)
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }}
            >
              {t(`service.addressAndDate.button.${renderBackButtonText()}`)}
            </B2becButtonBack>
          </div>
        </Col>
        <Col
          lg={{ span: 8, push: 8 }}
          md={{ span: 12, order: 2 }}
          sm={{ order: 1 }}
          span={24}
          xs={{ order: 1 }}
        >
          <div className="service-request__layout--shrink">
            <CustomButton
              block
              onClick={() => {
                handleChangeTab(+currentTab + 1)
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }}
            >
              {t('service.button.next')}
            </CustomButton>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default AddressAndDateSelectStep
